var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Comments',_vm._g(_vm._b({attrs:{"data-testid":"fc-conversation"}},'Comments',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }